
















































import { RootState } from '@/store/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ModuleResponseDTO } from '@/jbi-shared/dto/jtms.dtos';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { ToastProgrammatic } from 'buefy';
import { UpdateModuleApiDTO } from '@/store/modules/jtms/module/module.types';
import { ModuleStatus } from '@/jbi-shared/types/jtms.types';

@Component({})
export default class ActivateArchiveModuleConfirmationModal extends Vue {
  @Prop({ type: Object }) module!: ModuleResponseDTO;
  @Prop({ type: Boolean, default: false }) isActivateModule!: boolean;

  @Action('module/updateModule')
  updateModule!: (options: UpdateModuleApiDTO) => void;

  @State((state: RootState) => state.module.apiState.updateModule)
  updateModuleApiState!: ApiState;

  closeModal() {
    this.$emit('close');
  }

  triggerPageRefresh() {
    this.$emit('refreshPage');
  }

  activateModule() {
    this.isActivateModule = true;
    const payload: UpdateModuleApiDTO = {
      moduleId: this.module.id,
      status: ModuleStatus.ACTIVE
    };

    this.updateModule(payload);
  }

  archiveModule() {
    this.isActivateModule = false;
    const payload: UpdateModuleApiDTO = {
      moduleId: this.module.id,
      status: ModuleStatus.ARCHIVED
    };

    this.updateModule(payload);
  }

  @Watch('updateModuleApiState', { deep: true })
  onUpdateModuleApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course Module successfully ${
          this.isActivateModule ? 'activated' : 'archived'
        }.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }
}
